// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 22 2023
 **/

import { forwardRef, Ref } from "react";
import { IconProps } from "../Icon";
import Svg from "@/frameworks/designStuff/components/Contents/Icon/Svg";
const PDFExtension = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy: string | undefined = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 36 36"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<rect width={36} height={36} rx={8} fill="#BC3B3B" />
				<g opacity={0.9}>
					<path
						d="M7.24219 13.5156H10.7109C11.3398 13.5156 11.8867 13.6387 12.3516 13.8848C12.8164 14.127 13.1738 14.4688 13.4238 14.9102C13.6738 15.3516 13.7988 15.8613 13.7988 16.4395C13.7988 17.0215 13.6719 17.5312 13.418 17.9688C13.168 18.4023 12.8047 18.7402 12.3281 18.9824C11.8516 19.2207 11.293 19.3398 10.6523 19.3398H8.49023V17.7578H10.2949C10.6035 17.7578 10.8652 17.7051 11.0801 17.5996C11.2949 17.4902 11.457 17.3359 11.5664 17.1367C11.6758 16.9375 11.7305 16.7051 11.7305 16.4395C11.7305 16.1699 11.6758 15.9375 11.5664 15.7422C11.457 15.5469 11.293 15.3965 11.0742 15.291C10.8594 15.1855 10.5977 15.1328 10.2891 15.1328H9.23438V22H7.24219V13.5156Z"
						fill="white"
					/>
					<path
						d="M15.6504 22V20.2949H17.8301C18.3301 20.2949 18.7461 20.209 19.0781 20.0371C19.4102 19.8652 19.6602 19.5938 19.8281 19.2227C20 18.8516 20.0859 18.3633 20.0859 17.7578C20.0859 17.1523 20 16.6621 19.8281 16.2871C19.6562 15.9121 19.4023 15.6406 19.0664 15.4727C18.7344 15.3047 18.3164 15.2207 17.8125 15.2207H15.6152V13.5156H17.9062C18.7656 13.5156 19.5098 13.6836 20.1387 14.0195C20.7676 14.3555 21.25 14.8438 21.5859 15.4844C21.9219 16.125 22.0898 16.8828 22.0898 17.7578C22.0898 18.6328 21.9219 19.3887 21.5859 20.0254C21.25 20.6621 20.7676 21.1504 20.1387 21.4902C19.5098 21.8301 18.7656 22 17.9062 22H15.6504ZM16.793 22H14.8008V13.5156H16.793V22Z"
						fill="white"
					/>
					<path
						d="M23.2734 13.5156H29.0273V15.1445H25.2656V16.9434H28.6582V18.5664H25.2656V22H23.2734V13.5156Z"
						fill="white"
					/>
				</g>
			</Svg>
		);
	}
);
PDFExtension.defaultProps = {
	size: 36,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default PDFExtension;
